import React, { CSSProperties } from 'react'

export default function useRenewalApplicationsModalContent() {
  const truncateStyle: CSSProperties = {
    width: '40%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 0.5px',
    borderRadius: '2px',
    textAlign: 'center',
  }

  const BeforeAfterCompare = ({
    before,
    after,
  }: {
    before?: any
    after?: any
  }) => {
    return (
      <div style={{ display: 'flex', gap: '3px' }}>
        <div
          style={{
            ...truncateStyle,
            textDecoration: before ? 'line-through' : 'none',
          }}
        >
          <span
            style={{
              backgroundColor: '#ff8283',
            }}
          >
            {['', undefined].includes(before) ? 'ㅤㅤㅤㅤ' : String(before)}
          </span>
        </div>
        <div>→</div>
        <div style={{ ...truncateStyle }}>
          <span
            style={{
              backgroundColor: '#86e856',
            }}
          >
            {['', undefined].includes(after) ? 'ㅤㅤㅤㅤ' : String(after)}
          </span>
        </div>
      </div>
    )
  }

  return {
    BeforeAfterCompare,
  }
}
